<template>
  <div>
    <!-- Mobile menu -->
    <TransitionRoot as="template" :show="mobileMenuOpen">
      <Dialog class="relative z-40 lg:hidden" @close="mobileMenuOpen = false">
        <TransitionChild as="template" enter="transition-opacity ease-linear duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="transition-opacity ease-linear duration-300" leave-from="opacity-100" leave-to="opacity-0">
          <div class="fixed inset-0 bg-black/25" />
        </TransitionChild>

        <div class="fixed inset-0 z-40 flex">
          <TransitionChild as="template" enter="transition ease-in-out duration-300 transform" enter-from="-translate-x-full" enter-to="translate-x-0" leave="transition ease-in-out duration-300 transform" leave-from="translate-x-0" leave-to="-translate-x-full">
            <DialogPanel class="relative flex w-full max-w-xs flex-col overflow-y-auto bg-white pb-12 shadow-xl">
              <div class="flex px-4 pb-2 pt-5">
                <button type="button" class="-m-2 inline-flex items-center justify-center rounded-md p-2 text-gray-400" @click="mobileMenuOpen = false">
                  <span class="sr-only">Close menu</span>
                  <XMarkIcon class="size-6" aria-hidden="true" />
                </button>
              </div>

              <!-- Links -->
              <TabGroup as="div" class="mt-2">
                <div class="border-b border-gray-200">
                  <TabList class="-mb-px flex space-x-8 px-4">
                    <Tab as="template" v-for="category in navigation.categories" :key="category.name" v-slot="{ selected }">
                      <button :class="[selected ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-gray-900', 'flex-1 whitespace-nowrap border-b-2 px-1 py-4 text-base font-medium']">{{ category.name }}</button>
                    </Tab>
                  </TabList>
                </div>
                <TabPanels as="template">
                  <TabPanel v-for="category in navigation.categories" :key="category.name" class="space-y-12 px-4 py-6">
                    <div class="grid grid-cols-2 gap-x-4 gap-y-10">
                      <div>
                        <h1><b>Categorias</b></h1>
                        <p v-for="item in category.subcategories" :key="item.name" aria-hidden="true" class="mt-1 text-sm font-medium text-gray-900">{{ item.name }}</p>
                      </div>
                      <div>
                        <h1><b>Formas</b></h1>
                        <p v-for="item in navigation.shapes" :key="item.name" aria-hidden="true" class="mt-1 text-sm font-medium text-gray-900">{{ item.name }}</p>
                      </div>
                      <div class="grid">
                        <h1><b>Marcas</b></h1>
                        <div class="flex space-x-4">
                          <p v-for="item in navigation.brands" :key="item.name" aria-hidden="true" class="mt-1 text-sm font-medium text-gray-900">{{ item.name }}</p>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                </TabPanels>
              </TabGroup>

              <div class="space-y-6 border-t border-gray-200 px-4 py-6">
                <div v-for="page in navigation.pages" :key="page.name" class="flow-root">
                  <a :href="page.href" class="-m-2 block p-2 font-medium text-gray-900">{{ page.name }}</a>
                </div>
              </div>

              <div class="space-y-6 border-t border-gray-200 px-4 py-6">
                <div class="flow-root">
                  <a href="#" class="-m-2 block p-2 font-medium text-gray-900">Registrate</a>
                </div>
                <div class="flow-root">
                  <a href="#" class="-m-2 block p-2 font-medium text-gray-900">Inicia sesión</a>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>

    <!-- Hero section -->
    <div class="relative bg-gray-900">
      <!-- Decorative image and overlay -->
      <div v-if="$route.name === 'home'" aria-hidden="true" class="absolute inset-0 overflow-hidden">
        <img src="@/assets/002.jpg" alt="" class="size-full object-cover" />        
      </div>
      <div v-if="$route.name === 'home'" aria-hidden="true" class="absolute inset-0 bg-gray-900 opacity-50" />
      <!-- Navigation -->
      <header class="relative z-10">
        <nav aria-label="Top">
          <!-- Top navigation -->
          <div class="bg-gray-900">
            <div class="mx-auto flex h-10 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
            </div>
          </div>

          <!-- Secondary navigation -->
          <div class="bg-white/10 backdrop-blur-md backdrop-filter">
            <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
              <div>
                <div class="flex h-16 items-center justify-between">
                  <!-- Logo (lg+) -->
                  <div class="hidden lg:flex lg:flex-1 lg:items-center">
                    <a href="#">
                      <span class="sr-only">Oftalmolents</span>
                      <!-- <img class="h-8 w-auto" src="https://tailwindui.com/plus/img/logos/mark.svg?color=white" alt="" /> -->
                      <!-- <img class="h-8 w-auto" src="@/assets/oftalmo_logo.png" alt="" /> -->
                      <router-link
                      to="/"
                      class="flex items-center text-sm font-medium text-white">
                        <img class="h-12 w-auto z-20" src="@/assets/logo_blanco.png" alt="" />
                      </router-link>
                      <!-- <b class="text-white">Oftalmolents</b> -->
                    </a>
                  </div>




                  <SuperMenu class="hidden h-full lg:flex" :navigation="navigation"></SuperMenu>


                  <!-- Mobile menu and search (lg-) -->
                  <div class="flex flex-1 items-center lg:hidden">
                    <button type="button" class="-ml-2 p-2 text-white" @click="mobileMenuOpen = true">
                      <span class="sr-only">Open menu</span>
                      <Bars3Icon class="size-6" aria-hidden="true" />
                    </button>

                    <!-- Search -->
                    <a href="#" class="ml-2 p-2 text-white">
                      <span class="sr-only">Search</span>
                      <MagnifyingGlassIcon class="size-6" aria-hidden="true" />
                    </a>
                  </div>

                  <!-- Logo (lg-) -->
                  <a href="#" class="lg:hidden">
                    <span class="sr-only">Your Company</span>
                    <!-- <img src="https://tailwindui.com/plus/img/logos/mark.svg?color=white" alt="" class="h-8 w-auto" /> -->
                    <img alt="" class="h-8 w-auto" src="@/assets/logo_blanco.png" />
                  </a>

                  <div class="flex flex-1 items-center justify-end">
                    <a href="#" class="hidden text-sm font-medium text-white lg:block">Search</a>

                    <div class="flex items-center lg:ml-8">
                      <!-- Help -->
                      <a href="#" class="p-2 text-white lg:hidden">
                        <span class="sr-only">Help</span>
                        <QuestionMarkCircleIcon class="size-6" aria-hidden="true" />
                      </a>
                      <a href="#" class="hidden text-sm font-medium text-white lg:block">Help</a>

                      <!-- Cart -->
                      <div class="ml-4 flow-root lg:ml-8">
                        <a href="#" class="group -m-2 flex items-center p-2">
                          <ShoppingBagIcon class="size-6 shrink-0 text-white" aria-hidden="true" />
                          <span class="ml-2 text-sm font-medium text-white">0</span>
                          <span class="sr-only">items in cart, view bag</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>
      <div v-if="$route.name === 'home'" class="relative mx-auto flex max-w-3xl flex-col items-center px-6 py-32 text-center sm:py-64 lg:px-0">
        <h1 class="text-4xl font-bold tracking-tight text-white lg:text-6xl">
          ¡Nuevas colecciones disponibles!
        </h1>
        <p class="mt-4 text-xl text-white">
          Descubre los últimos modelos de nuestra colección exclusiva de verano. 
          Diseños únicos y en stock limitado. ¡No te quedes sin los tuyos!
        </p>
        <a 
          href="#"
          class="mt-8 inline-block rounded-md border border-transparent bg-white px-8 py-3 text-base font-medium text-gray-900 hover:bg-gray-100"
        >
          Explorar Nuevas Colecciones
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import SuperMenu from './SuperMenu.vue';
  import { getCategories, Category, Brand, Shape } from '@/services/api/navigationService';
  import { ref, onMounted } from 'vue';
  import {
    Dialog,
    DialogPanel,
    Popover,
    PopoverButton,
    PopoverGroup,
    PopoverPanel,
    Tab,
    TabGroup,
    TabList,
    TabPanel,
    TabPanels,
    TransitionChild,
    TransitionRoot,
  } from '@headlessui/vue'
  import {
    Bars3Icon,
    MagnifyingGlassIcon,
    QuestionMarkCircleIcon,
    ShoppingBagIcon,
    XMarkIcon,
  } from '@heroicons/vue/24/outline'
  const mobileMenuOpen = ref(false)
  const navigation = ref({
    categories: [] as Category[], // Inicializamos vacío
    brands: [] as Brand[], // Inicializamos vacío
    shapes: [] as Shape[], // Inicializamos vacío
    pages: [
      { name: 'Tecnologías', href: '/technologies' },
      { name: 'Revisión Visual', href: '/visual-review' },
      { name: 'Nuestras Tiendas', href: '/stores' },
    ],
  });
  const loading = ref(true);
  const error = ref<string | null>(null);
  onMounted(async () => {
    try {
      const data = await getCategories();
      navigation.value.categories = data.categories; // Asignamos las categorías
      navigation.value.brands = data.brands; // Asignamos las marcas
      navigation.value.shapes = data.shapes; // Asignamos las formas
    } catch (err) {
      error.value = 'Error loading categories';
      console.error(err);
    } finally {
      loading.value = false;
    }
  });
</script>
<style scoped>
/* Custom Styles if necessary */
</style>
